<template>
  <!-- 推荐有礼 -->
  <div class="page-container">
    <h3>{{ $t('myAccount.menu[3]') }}</h3>
    <div class="container">
      <h3 v-text="`${$t('myAccount.gift[0]')}`"></h3>
      <div class="tips">
        <span>{{ $t('myAccount.gift[1]') }}</span>
        <span class="gift"><b-svg-icon type="iconYbi"></b-svg-icon>1000</span>
        <span v-if="$i18n.locale=='zh_CN'">{{ $t('myAccount.gift[2]') }}<a :href="ybStoreUrl" target="_blank">{{ $t('myAccount.yMall') }}</a>{{ $t('myAccount.gift[3]') }}</span>
        <span v-if="$i18n.locale=='en_US'">{{ $t('myAccount.gift[2]') }}{{ $t('myAccount.gift[3]') }}<a :href="ybStoreUrl" target="_blank">{{ $t('myAccount.yMall') }}</a>)</span>
      </div>
      <!-- 推荐码相关 -->
      <div class="code-box">
        <div class="recommended">{{ $t('myAccount.gift[4]') }}<span v-text="alreadyRecNum"></span>{{ $t('myAccount.gift[5]') }}</div>
        <img class="qrcode" :src="recommendationCode" alt="">
        <div class="recommended">{{ $t('myAccount.gift[6]') }}</div>
        <div class="operation-btn">
          <!-- 二维码链接复制 -->
          <!-- <a v-clipboard:copy="recommendationCode" v-clipboard:success="copySuccess" v-clipboard:error="copyError">{{ $t('myAccount.gift[7]') }}</a> -->
          <!-- 注册链接复制 -->
          <a v-clipboard:copy="regUrl" v-clipboard:success="copySuccess" v-clipboard:error="copyError">{{ $t('myAccount.gift[8]') }}</a>
        </div>
      </div>
    </div>
    <!-- 右下角底部的提示 -->
    <div class="bot-tips">{{ $t('myAccount.gift[9]') }}</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { apiMy } from '@/api/my'
import qs from 'qs'

export default {
  computed: {
    ...mapGetters(['token', 'userInfo']),
    parseUserInfo () {
      return JSON.parse(this.userInfo || '{}')
    },
    // 推荐码地址
    recommendationCode () {
      return `${this.$config.baseOAuthUrl}v1/user/qrcode?` + qs.stringify({
        width: 200,
        height: 200,
        code: this.parseUserInfo.ownRecommedCode
      })
    },
    // Y币商城各环境对应的地址
    ybStoreUrl () {
      return `${process.env.VUE_APP_SNSURL}account=${this.parseUserInfo.username}&token=${this.token}`
    },
    // 账号注册地址
    regUrl () {
      return `${process.env.VUE_APP_CAS_API_URL}/register?recommedCode=${this.parseUserInfo.ownRecommedCode}`
    }
  },
  data () {
    return {
      alreadyRecNum: 0 // 已成功推荐的人数
    }
  },
  created () {
    apiMy.recommendedNum().then(res => {
      // console.log(res)
      this.alreadyRecNum = res || 0
    })
  },
  methods: {
    /**
     * 复制到剪贴板-成功
     */
    copySuccess (e) {
      // console.log('You just copied: ' + e.text)
      this.$message.success(this.$t('robotDes.copyOK'))
    },
    /**
     * 复制到剪贴板-失败
     */
    copyError (e) {
      this.$message.error(this.$t('robotDes.copyError'))
    }
  }
}
</script>

<style lang="less" scoped>
  .page-container {
    position: relative;
    height: 100%;
    .bot-tips {
      position: absolute;
      bottom: 0px;
      right: 0px;
      color: #ccc;
    }
  }
  h3 {
    font-weight: bold;
    padding: 10px 0;
  }
  .container {
    text-align: center;
  }
  .tips {
    padding-bottom: 60px;
    a:hover {
      text-decoration: underline;
    }
    .gift {
      padding: 0 8px;
      font-weight: bold;
      color: #333;
    }
    em {
      color: #4977FC;
      text-decoration: underline;
    }
  }
  .code-box {
    margin: 0 auto;
    padding: 0 24px;
    width: 335px;
    height: 417px;
    background: rgba(255,255,255,1);
    border: 1px solid rgba(238,238,238,1);
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .recommended {
      padding-bottom: 16px;
      color: #666;
      >span {
        padding: 0 5px;
        font-size: 24px;
        color: #F5222D;
        font-weight: bold;
      }
    }
    .qrcode {
      margin-bottom: 16px;
    }
    .operation-btn {
      >a {
        &:first-of-type {
          margin-right: 28px;
        }
        &:last-of-type {
          margin-right: 0;
        }
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
</style>
